/**
 * Dates serveur et fuseau horaire (même règle que le site client).
 *
 * Le back sérialise ses horodatages en UTC **sans marqueur de fuseau**
 * (`yyyy-MM-dd'T'HH:mm[:ss]`) ; Dakar étant à UTC+0, c'est aussi l'heure Nawam.
 * Lus tels quels par `new Date()`, ils seraient interprétés en heure locale du
 * navigateur (décalage d'1–2 h pour un utilisateur en Europe : « il y a 1 h » au
 * lieu de « à l'instant », retards faux). Règles :
 * - les **instants** passent par {@link serverDate}, qui fixe l'offset manquant ;
 * - les **heures métier** s'affichent à l'heure de Dakar ({@link DAKAR_OFFSET}
 *   pour `formatDate`, {@link DAKAR_TZ} pour `Intl`).
 */
export const DAKAR_TZ = 'Africa/Dakar';
/** Dakar = UTC+0 toute l'année (pas d'heure d'été) — 4ᵉ argument de `formatDate`. */
export const DAKAR_OFFSET = '+0000';

const NO_OFFSET = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?)?$/;

/** Chaîne serveur (UTC sans offset) ou valeur déjà datée → instant exact. */
export function serverDate(v: string | number | Date): Date {
  if (v instanceof Date) return v;
  if (typeof v === 'number') return new Date(v);
  const s = v.trim();
  if (!NO_OFFSET.test(s)) return new Date(s);
  return new Date(s.length === 10 ? `${s}T00:00:00Z` : `${s}Z`);
}

const DAY_FMT = new Intl.DateTimeFormat('en-CA', { timeZone: DAKAR_TZ, year: 'numeric', month: '2-digit', day: '2-digit' });

/** Jour civil à Dakar (`YYYY-MM-DD`) d'un instant. */
export function dakarDay(v: string | number | Date): string {
  return DAY_FMT.format(serverDate(v));
}

/** Nombre de jours civils (à Dakar) entre `from` et `to` ; positif si `to` est après. */
export function dakarDayDiff(to: string | number | Date, from: string | number | Date = Date.now()): number {
  return Math.round((Date.parse(`${dakarDay(to)}T00:00:00Z`) - Date.parse(`${dakarDay(from)}T00:00:00Z`)) / 86_400_000);
}
